import { staticComponentValueConverter } from '../StaticComponentValues';

const BlogCard_1 = ({ item }) => {
  const customization = staticComponentValueConverter(item?.customization);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: customization?.imageDirection,
        gap: 10,
        padding: customization?.padding,
        backgroundColor: customization?.backgroundColor,
        borderRadius: customization?.borderRadius,
        border: `1px solid ${customization?.borderColor}`,
        margin: '10px',
      }}
    >
      <div style={{ width: customization?.imageDirection === 'row' ? '40%' : '100%' }}>
        <img
          src={customization?.image}
          style={{
            width: '100%',
            height: '100%',
            objectFit: customization?.imageBackgroundSize,
          }}
        />
      </div>
      <div style={{ width: customization?.imageDirection === 'row' ? '60%' : '100%' }}>
        <div
          style={{
            fontSize: customization?.titleTextSize,
            fontWeight: customization?.titleTextWeight,
            color: customization?.titleTextColor,
            letterSpacing: customization?.titleTextLetterSpacing,
            fontStyle: customization?.titleTextStyle,
            textAlign: customization?.titleTextAlignment,
          }}
        >
          {customization?.titleText}
        </div>
        <div
          style={{
            fontSize: customization?.dateTextSize,
            fontWeight: customization?.dateTextWeight,
            color: customization?.dateTextColor,
            letterSpacing: customization?.dateTextLetterSpacing,
            fontStyle: customization?.dateTextStyle,
            textAlign: customization?.dateTextAlignment,
          }}
        >
          {customization?.dateText}
        </div>
        <div
          style={{
            fontSize: customization?.descriptionTextSize,
            fontWeight: customization?.descriptionTextWeight,
            color: customization?.descriptionTextColor,
            letterSpacing: customization?.descriptionTextLetterSpacing,
            fontStyle: customization?.descriptionTextStyle,
            textAlign: customization?.descriptionTextAlignment,
          }}
          className={`${'line-clamp-3'}`}
        >
          {customization?.descriptionText}
        </div>
        <div
          style={{
            fontSize: customization?.buttonTextSize,
            fontWeight: customization?.buttonTextWeight,
            color: customization?.buttonTextColor,
            letterSpacing: customization?.buttonTextLetterSpacing,
            fontStyle: customization?.buttonTextStyle,
            textAlign: customization?.buttonTextAlignment,
            textDecoration: 'underline',
            textDecorationColor: customization?.buttonTextColor,
          }}
        >
          {customization?.buttonText}
        </div>
      </div>
    </div>
  );
};

export default BlogCard_1;
